export default {"src":"/_next/static/media/googlePlay.f91b1b0b.svg","height":80,"width":250,"blurWidth":0,"blurHeight":0};